<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span class="ms-1">
          {{ 'Settings::GenAIFeatureSettings' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-genai-feature-settings></ca-genai-feature-settings>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" style="height: calc(100% - 120px)"></div>
</div>
